// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__vJI_4","head":"Table_head__3Jv8K","col":"Table_col__3VJqK"};